import axios from 'axios'
import { config } from '../Config/config'

const menuService = {


    getByCode: (code) => {
        const result = axios.get(config.apiUrl + '/menuByCode/' + code)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getSubByCode: (code) => {
        const result = axios.get(config.apiUrl + '/menuByCodeSub/' + code)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },



    getByCodeM: (code) => {
        const result = axios.get(config.apiUrl + '/menuByCodeM/' + code)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getByCodeT: (code) => {
        const result = axios.get(config.apiUrl + '/menuByCodeT/' + code)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
}


export default menuService